module.exports = __webpack_public_path__ + "img/Last image OOBE Simplified Chinese.0e70308c.png";